import angular from 'angular';

import { WebsiteApiService } from './website-api.service';

const MODULE_NAME = 'core.services.website-api';

angular.module(MODULE_NAME, []).service('WebsiteApiService', WebsiteApiService);

export default MODULE_NAME;
